import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../Modal';

const ConfirmationModal = ({
  visible,
  onConfirm,
  onCancel,
  title,
  content,
  cancelText,
  confirmText,
}) => {
  if (!visible) return false;

  return (
    <Modal>
      <Modal.Header onCancel={onCancel}>
        <h5 className="modal-title">{title}</h5>
      </Modal.Header>
      <Modal.Body>
        {content}
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onCancel}>{cancelText}</button>
        <button
          type="button"
          className="btn btn-info"
          id="btn-confirm-button"
          onClick={onConfirm}
        >
          {confirmText}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  cancelText: PropTypes.string.isRequired,
  confirmText: PropTypes.string.isRequired,
};

export default ConfirmationModal;
